import { render, staticRenderFns } from "./HtSideBarItem.vue?vue&type=template&id=b64ba494&scoped=true"
import script from "./HtSideBarItem.vue?vue&type=script&lang=js"
export * from "./HtSideBarItem.vue?vue&type=script&lang=js"
import style0 from "./HtSideBarItem.vue?vue&type=style&index=0&id=b64ba494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64ba494",
  null
  
)

export default component.exports